import React from 'react';
import * as PropTypes from 'prop-types';
import Collapse from "@material-ui/core/Collapse";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import {withStyles} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import HeatExchangerInAddMenu from "../../components/plantManagement/HeatExchangerInAddMenu";

const styles = theme => ({
    listItemWrapper: {
        margin: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 4,
    }
});

export class HeatExchangerCollapseListItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };
    }

    render() {
        return (
            <div>
                <ListItem button onClick={() => {
                    this.setState({isOpen: !this.state.isOpen})
                }}>
                    <ListItemIcon>{this.state.isOpen ? <RemoveIcon/> : <AddIcon/>}</ListItemIcon>
                    <ListItemText primary={this.props.groupKey}/>
                </ListItem>
                <Collapse in={this.state.isOpen} timeout="auto" unmountOnExit>
                    {this.props.groupHeatExchangerArray.map((row, i) => {
                        return (
                            <HeatExchangerInAddMenu
                                key={i}
                                heatExchanger={row}
                                onClick={this.props.onClickHeatExchanger}
                                className={this.props.classes.listItemWrapper}
                            />
                        )
                    })}
                </Collapse>
            </div>
        );
    }
}

HeatExchangerCollapseListItem.propTypes = {
    groupHeatExchangerArray: PropTypes.array.isRequired,
    groupKey: PropTypes.string.isRequired,
    onClickHeatExchanger: PropTypes.func.isRequired
};

export default withStyles(styles)(HeatExchangerCollapseListItem);
